import { render, staticRenderFns } from "./PublicEcommerceOnboarding.vue?vue&type=template&id=9058b89a&scoped=true"
import script from "./PublicEcommerceOnboarding.vue?vue&type=script&lang=js"
export * from "./PublicEcommerceOnboarding.vue?vue&type=script&lang=js"
import style0 from "./PublicEcommerceOnboarding.vue?vue&type=style&index=0&id=9058b89a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9058b89a",
  null
  
)

export default component.exports